// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Dates-Planning2Dates-module__datesBox--RM0To {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Dates-Planning2Dates-module__datesBox--RM0To .ant-picker {
  width: 100%;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Dates-Planning2Dates-module__datesBox--RM0To .ant-form-item-label {
  padding: 0 !important;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Dates-Planning2Dates-module__datesBox--RM0To .ant-form-item-explain-error {
  color: #c20034;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsPlanning2/Planning2Control/Planning2Dates/Planning2Dates.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AACF;AAJA;EAKI,WAAA;AAEJ;AAPA;EAQI,qBAAA;AAEJ;AAVA;EAWI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEJ","sourcesContent":[".datesBox {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  :global(.ant-picker) {\n    width: 100%;\n  }\n  :global(.ant-form-item-label) {\n    padding: 0 !important;\n  }\n  :global(.ant-form-item-explain-error) {\n    color: #c20034;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"datesBox": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Dates-Planning2Dates-module__datesBox--RM0To`
};
export default ___CSS_LOADER_EXPORT___;
